import RouteTemplate from 'ember-route-template'
import { ErrorsSubscriptionTypeErrorPage } from 'teacher-ui-client/components/errors/subscription-type-error-page'

// This error page will be rendered inside the application / subscription-type template, it should have a navbar and sidenav
export default RouteTemplate(ErrorsSubscriptionTypeErrorPage)
